/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, SAMPLE_TO_SALE_SCREEN, COMMON, API_CONSTANTS } from '../../global/Constants';
import './sample-to-sale.css';
import Header from '../common/Header';
import { ActivityStatusType, HeaderTypes } from "../../global/Enum";
import DesktopFooter from '../common/DesktopFooter';
import ActivityHeader from '../common/ActivityHeader';
import Select, { components } from 'react-select';
import AddNumberImages from '../common/AddNumberImages';
import AddNewImages from '../common/AddNewImages';
import Utilities from '../../global/Utilities';
//import ApiServices from "../../providers/ApiServices";
import Loader from "../common/loader/Loader";
import SyncLoader from '../common/loader/SyncLoader';
import DataProvider from '../../providers/DataProvider';
import SyncServices from '../../providers/SyncServices';

const Menu = props => {
    const optionSelectedLength = props.getValue().length || 0;
    return (
        <components.Menu {...props}>
            {optionSelectedLength < props.selectProps.maxLength ? (
                props.children
            ) : (
                <div style={{ margin: 15 }}>Max limit achieved</div>
            )}
        </components.Menu>
    );
};

class EditFieldDayPage extends Component {
    constructor(props) {
        super(props);
        this.latitude = null;
        this.longitude = null;

        this.state = {
            isLoading: false,
            activity: null,
            data: null,
            feedback: '',

            farmerNumbers: [],
            farmerNumberImages: [],
            images: [],

            farmerCount: "",
            retailerCount: "",
            prerakCount: "",
            farmersCommitment: '',

            selectedUsers: [],
            selectedManagers: [],
            selectedRetailers: [],
            selectedPreraks: [],

            attendedUsers: [
                { value: 1, label: "Farmer" },
                { value: 2, label: "Retailer" },
                { value: 3, label: "Prerak" },
                { value: 4, label: "SeedWorks(Managers)" },
            ],

            managers: [
                { value: 1, label: "TM" },
                { value: 2, label: "GM" },
                { value: 3, label: "RM" },
                { value: 4, label: "SE" },
            ],

            retailerData: [],
            prerakData: [],
            regexp: /^[0-9]/,
            deletedImages: []
        }
    }

    componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state !== undefined) {
                let activity = this.props.location.state.activity;
                if (activity !== undefined && activity !== null) {
                    //let data = activity?.stage;
                    //const managers = data ?.params ?.field_day_manager ?.map(({ field_day_manager_id: value, name: label, ...rest }) => ({ value, label, ...rest }));

                    this.setState({
                        activity: activity,
                        //managers: managers
                    }, () => {
                        this.getParams();

                        if (activity?.fieldDay != null) {
                            let fieldDay = activity?.fieldDay;
                            this.setState({
                                selectedUsers: fieldDay.selectedUsers,
                                selectedManagers: fieldDay.selectedManagers,
                                selectedRetailers: fieldDay.selectedRetailers,
                                selectedPreraks: fieldDay.selectedPreraks,
                                farmerCount: fieldDay.farmerCount,
                                farmersCommitment: fieldDay.farmersCommitment,
                                retailerCount: fieldDay.retailerCount,
                                prerakCount: fieldDay.prerakCount,
                                feedback: fieldDay.feedback,

                                images: fieldDay?.images,
                                farmerNumberImages: fieldDay?.farmerNumberImages,
                                farmerNumbers: fieldDay?.farmerNumbers,
                                deletedImages: fieldDay?.deletedImages
                            });
                        } else {
                            this.setData();
                        }
                    });
                    this.getPreraks();
                }
                this.getUserLocation();

            } else {
                this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE)
        }

    }

    getUserLocation = async () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                const coords = position.coords;
                this.latitude = coords.latitude.toFixed(6);
                this.longitude = coords.longitude.toFixed(6);

            }, (error) => {
                Utilities.LogPrint("Error Code = " + error.code + " - " + error.message);
            });
        }
    }

    setData = () => {
        const { activity } = this.state;
        if (activity !== null && activity.activity_status_id !== ActivityStatusType.TO_START) {
            const fieldDay = activity?.data?.history?.stage_four?.[0];

            if (fieldDay !== undefined && fieldDay !== null) {

                // Set For Attended Users
                let selectedUsers = [];
                selectedUsers.push({ value: 1, label: "Farmer" })

                if (fieldDay?.field_day_dealers.length > 0) {
                    selectedUsers.push({ value: 2, label: "Retailer" });
                }

                if (fieldDay?.field_day_preraks.length > 0) {
                    selectedUsers.push({ value: 3, label: "Prerak" });
                }

                if (fieldDay?.field_day_manager_bies.length > 0) {
                    selectedUsers.push({ value: 4, label: "SeedWorks(Managers)" });
                }

                // Set Managers
                let selectedManagers = [];
                if (fieldDay?.field_day_manager_bies.length > 0) {
                    fieldDay?.field_day_manager_bies.forEach(element => {
                        selectedManagers.push({
                            value: element.field_day_manager_id,
                            label: element.field_day_manager_name
                        });
                    });
                }


                // Set Retailers
                let selectedRetailers = [];
                if (fieldDay?.field_day_dealers.length > 0) {
                    fieldDay?.field_day_dealers.forEach(element => {
                        selectedRetailers.push({
                            value: element.field_day_dealer_id,
                            label: element.field_day_dealer_name,
                            name: element.field_day_dealer_name,
                            commitment: element.commitment
                        });
                    });
                }

                // Set Preraks
                let selectedPreraks = [];
                if (fieldDay?.field_day_preraks.length > 0) {
                    fieldDay?.field_day_preraks.forEach(element => {
                        selectedPreraks.push({
                            value: element.field_day_prerak_id,
                            label: element.field_day_prerak_name,
                            name: element.field_day_prerak_name,
                            commitment: element.commitment
                        });
                    });
                }

                // Set Farmer Numbers
                let farmerNumbers = [];
                if (fieldDay?.field_day_farmers.length > 0) {
                    fieldDay?.field_day_farmers.forEach(element => {
                        if (element.is_phone === 1)
                            farmerNumbers.push({
                                phone: element.phone_image
                            });
                    });
                }

                // Set Farmer Number Images
                let farmerNumberImages = [];
                if (fieldDay?.field_day_farmers.length > 0) {
                    fieldDay?.field_day_farmers.forEach(element => {
                        if (element.is_phone === 0)
                            farmerNumberImages.push({
                                image_url: element.phone_image
                            });
                    });
                }

                this.setState({
                    selectedUsers: selectedUsers,
                    selectedManagers: selectedManagers,
                    selectedRetailers: selectedRetailers,
                    selectedPreraks: selectedPreraks,
                    farmerCount: fieldDay.farmer_count,
                    farmersCommitment: fieldDay.farmer_commitment,
                    retailerCount: fieldDay.field_day_dealers.length,
                    prerakCount: fieldDay.field_day_preraks.length,
                    feedback: fieldDay.feedback,

                    images: fieldDay?.images,
                    farmerNumberImages: farmerNumberImages,
                    farmerNumbers: farmerNumbers
                });
            }
        }
    }


    getParams = () => {
        const managers = DataProvider.getInstance().getFieldDayManagers();
        Utilities.LogPrint("Managers:-", managers);
        if (managers.length > 0) {
            this.setState({
                managers: managers?.map(({ field_day_manager_id: value, name: label, ...rest }) => ({ value, label, ...rest }))
            });
        }

        const retailers = DataProvider.getInstance().getRetailers();
        Utilities.LogPrint("Retailers:-", retailers);
        if (retailers.length > 0) {
            let retailerDataArray = [];
            retailers.forEach(element => {
                let obj = {
                    value: element.retailer_id,
                    label: element.retailer_name + " - " + element.phone,
                    name: element.retailer_name
                }
                retailerDataArray.push(obj);
            });
            this.setState({ retailerData: retailerDataArray });
        }
    }

    getPreraks = () => {
        SyncServices.getKrishakFromDatabase("is_prerak", "true").then(data => {
            if (data) {
                if (data.is_active === undefined || data.is_active === null || data.is_active === 1) {

                    let preraks = [];
                    for (let i = 0; i < data.length; i++) {
                        const element = data[i].data;
                        let prerak = {
                            value: element.krishak_id,
                            label: element.name + " - " + element.phone,
                            name: element.name
                        }
                        preraks.push(prerak);
                    }
                    this.setState({ prerakData: preraks });
                }
            }
        });
    }

    handleBackButton = () => {
        this.props.history.replace({
            pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
            state: { activity: this.state.activity }
        });
    }

    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    onFarmerCountChange = e => {
        let count = e.target.value;
        if (count === '' || this.state.regexp.test(count)) {
            this.setState({ farmerCount: count })
        }
    }

    onRetailerCountChange = e => {
        let count = e.target.value;
        if (count === '' || this.state.regexp.test(count)) {
            this.setState({ retailerCount: count })
        }
    }

    onPrerakCountChange = e => {
        let count = e.target.value;
        if (count === '' || this.state.regexp.test(count)) {
            this.setState({ prerakCount: count })
        }
    }

    handleAttendedUsersChange = item => {
        this.setState({ selectedUsers: item });
    };

    handleManagerChange = item => {
        this.setState({ selectedManagers: item })
    };

    handleRetailerChange = selectedRetailers => {
        this.setState({ selectedRetailers });
    };

    handlePrerakChange = selectedPreraks => {
        this.setState({ selectedPreraks });
    };

    isVisible(val) {
        return this.state.selectedUsers.some(item => item.value === val);
    }

    handleNumbers = (numbers) => {
        this.setState({ farmerNumbers: numbers });
    }

    handleNumberImages = (images) => {
        this.setState({ farmerNumberImages: images });
    }

    handleAddImages = (images) => {
        this.setState({ images: images });
    }

    handleDeleteImages = (deletedImage) => {
        var deletedImagesArray = this.state.deletedImages.slice();
        deletedImagesArray.push({ image_id: deletedImage.image_id });
        if (deletedImagesArray.length > 0) {
            Utilities.LogPrint("DeletedImages", deletedImagesArray);
            this.setState({ deletedImages: deletedImagesArray });
        }
    }

    handleRetailerCommitmentChange = (i, item) => e => {
        const { selectedRetailers } = this.state;
        let retailers = [...selectedRetailers];
        retailers[i] = { ...retailers[i], commitment: e.target.value };
        this.setState({ selectedRetailers: retailers })
    };

    handlePrerakCommitmentChange = (i, item) => e => {
        const { selectedPreraks } = this.state;
        let preraks = [...selectedPreraks];
        preraks[i] = { ...preraks[i], commitment: e.target.value };
        this.setState({ selectedPreraks: preraks })
    };

    handleSaveButton = () => {
        const { selectedUsers, selectedManagers, farmerCount, farmersCommitment, farmerNumbers,
            farmerNumberImages, images, selectedRetailers, selectedPreraks, retailerCount, prerakCount, feedback, deletedImages } = this.state;

        let fieldDay = {
            selectedUsers: selectedUsers,
            selectedManagers: selectedManagers,
            selectedRetailers: selectedRetailers,
            selectedPreraks: selectedPreraks,

            farmerCount: farmerCount,
            farmersCommitment: farmersCommitment,
            retailerCount: retailerCount,
            prerakCount: prerakCount,

            farmerNumbers: farmerNumbers,
            farmerNumberImages: farmerNumberImages,
            images: images,
            feedback: feedback,
            deletedImages: deletedImages,
            latitude: this.latitude,
            longitude: this.longitude
        }

        this.setState(prevState => ({
            activity: { ...prevState.activity, fieldDay: fieldDay }
        }), () => {
            Utilities.LogPrint("fieldDay", this.state.activity);

            if (!this.state.activity?.isEdit) {
                this.props.history.replace({
                    pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
                    state: { activity: this.state.activity }
                });
            } else {
                this.props.history.replace({
                    pathname: ALL_ROUTES.EDIT_SAMPLE_TO_SALE,
                    state: { activity: this.state.activity }
                });
            }

            // this.props.history.replace({
            //     pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
            //     state: { activity: this.state.activity }
            // });
        });

        // const users = selectedUsers.map(item => {
        //     return item.value
        // });

        // const managers = selectedManagers.map(item => {
        //     return item.value
        // });

        // let retailers = [];
        // selectedRetailers.forEach(element => {
        //     let retailer = {
        //         dealer_id: element.value,
        //         commitment: element.commitment,
        //         commitment_weight_id: 1
        //     };
        //     retailers.push(retailer)
        // });

        // let preraks = [];
        // selectedPreraks.forEach(element => {
        //     let prerak = {
        //         prerak_id: element.value,
        //         commitment: element.commitment,
        //         commitment_weight_id: 1
        //     };
        //     preraks.push(prerak)
        // });

        // let request = {
        //     field_day_attend_by: users,
        //     field_day_manager: managers,
        //     farmer_count: farmerCount,
        //     farmer_commitment: farmersCommitment,

        //     field_day_farmer: farmerNumbers,
        //     field_day_farmer_image: farmerNumberImages,
        //     images: images,
        // }

        // let fieldDayObj = {
        //     field_day_attend_by: users,
        //     field_day_manager: managers,
        //     farmer_count: farmerCount,
        //     farmer_commitment: farmersCommitment,
        //     farmer_commitment_weight_id: 1,

        //     field_day_farmer: farmerNumbers,
        //     field_day_dealer: retailers,
        //     field_day_prerak: preraks,

        //     feedback_id: 1
        // }
        // Utilities.LogPrint("FieldDayObj:-", fieldDayObj);

        // const formData = new FormData();
        // formData.append("activity_id", activity.activity_id);
        // formData.append("stage_id", data?.stage_id);
        // formData.append("field_days", JSON.stringify(fieldDayObj));
        // formData.append("field_day_farmer_image",farmerNumberImages);
    }


    isFormValid() {
        const { selectedUsers, farmersCommitment, images } = this.state;
        return selectedUsers.length === 0 || !farmersCommitment || images.length === 0;
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isSyncLoading, tableName } = this.state;
        const { isLoading, activity, feedback, attendedUsers, managers, retailerData, prerakData, selectedRetailers, selectedPreraks,
            farmerCount, retailerCount, prerakCount, farmersCommitment, selectedUsers, selectedManagers,
            farmerNumbers, farmerNumberImages, images } = this.state;

        const retailersLists = selectedRetailers?.map((item, i) => {
            return (
                <div className="form-group acre-form-group row align-items-center" key={i}>
                    <div className="col-6 col-lg-6 col-xl-4">
                        <label className="font-weight-medium mb-0">{item.name}</label>
                    </div>
                    <div className="col-6 col-lg-6 col-xl-8">
                        <div className="form-control">
                            <input type="text" placeholder="Commitment" value={item?.commitment} onChange={this.handleRetailerCommitmentChange(i, item)} /><span>kg</span>
                        </div>
                    </div>
                </div>
            )
        });

        const prerakLists = selectedPreraks?.map((item, i) => {
            return (
                <div className="form-group acre-form-group row align-items-center" key={i}>
                    <div className="col-6 col-lg-6 col-xl-4">
                        <label className="font-weight-medium mb-0">{item.name}</label>
                    </div>
                    <div className="col-6 col-lg-6 col-xl-8">
                        <div className="form-control">
                            <input type="text" placeholder="Commitment" value={item?.commitment} onChange={this.handlePrerakCommitmentChange(i, item)} /><span>kg</span>
                        </div>
                    </div>
                </div>
            )
        });

        return (
            <div>
                <Header selectedTab={HeaderTypes.TODAY} handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-xl-6 col-lg-7 col-md-9 col-12">
                            <ActivityHeader
                                type={4}
                                code={activity?.activity_tag}
                                title={SAMPLE_TO_SALE_SCREEN.FIELD_DAY}
                                subTitle={activity?.crop_name + ", " + activity?.hybrid_name + " | " + activity?.village_name} />
                        </div>
                        <div className="col-xl-6 col-lg-5 col-md-3 d-md-flex back-btn d-none">
                            <button className="btn btn-secondary min-w-182 krishak-cancel-btn" onClick={this.handleBackButton}>Back</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <form>
                                <div className="harvest-details">
                                    <div className="row mt-3">
                                        <div className="col-12 col-md-6 col-lg-4">
                                            <div className="form-group row align-items-center">
                                                <div className="col-12">
                                                    <label className="font-weight-medium d-block">Attended By</label>
                                                </div>
                                                <div className="col-12 col-lg-12 col-xl-8 max-w-360">
                                                    <Select
                                                        isMulti
                                                        value={selectedUsers}
                                                        options={attendedUsers}
                                                        onChange={this.handleAttendedUsersChange}
                                                        placeholder="Select the User"
                                                        className="basic-multi-select"
                                                        isClearable={false} />
                                                </div>
                                            </div>
                                        </div>

                                        {/* For Managers */}
                                        {
                                            this.isVisible(4) ?
                                                <div className="col-12 col-md-6 col-lg-4">
                                                    <div className="form-group row align-items-center">
                                                        <div className="col-12">
                                                            <label className="font-weight-medium d-block">Managers</label>
                                                        </div>
                                                        <div className="col-12 col-lg-12 col-xl-8 max-w-360">
                                                            <Select
                                                                isMulti
                                                                value={selectedManagers}
                                                                options={managers}
                                                                onChange={this.handleManagerChange}
                                                                placeholder="Select the Type"
                                                                isClearable={false}
                                                                className="basic-multi-select" />
                                                        </div>
                                                    </div>
                                                </div> : null
                                        }

                                    </div>
                                </div>

                            </form>
                        </div>


                        <div className="col-lg-5 mt-0 mt-md-3">
                            {/* For Farmer */}
                            {
                                this.isVisible(1) ?
                                    <div>
                                        <div className="form-group acre-form-group row align-items-center">
                                            <div className="col-6 col-lg-6 col-xl-4">
                                                <label className="font-weight-medium mb-0">Farmer Count</label>
                                            </div>
                                            <div className="col-6 col-lg-6 col-xl-8">
                                                <input className="form-control border-right0" type="number" placeholder="0"
                                                    value={farmerCount} onChange={this.onFarmerCountChange} />
                                            </div>
                                        </div>
                                        <div className="form-group acre-form-group row align-items-center">
                                            <div className="col-6 col-lg-6 col-xl-4">
                                                <label className="font-weight-medium mb-0">Farmers</label>
                                            </div>
                                            <div className="col-6 col-lg-6 col-xl-8">
                                                <div className="form-control">
                                                    <input type="text" placeholder="Commitment"
                                                        name="farmersCommitment" value={farmersCommitment} onChange={this.changeHandler} />
                                                    <span>kg</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }

                            {/* For Retailer */}
                            {
                                this.isVisible(2) ?
                                    <div>
                                        <div className="form-group acre-form-group row align-items-center">
                                            <div className="col-6 col-lg-6 col-xl-4">
                                                <label className="font-weight-medium mb-0">Retailer Count</label>
                                            </div>
                                            <div className="col-6 col-lg-6 col-xl-8">
                                                <input className="form-control border-right0" type="number" placeholder="0"
                                                    value={retailerCount} onChange={this.onRetailerCountChange} />
                                            </div>
                                        </div>
                                        <div className="form-group row align-items-center">
                                            <div className="col-12 col-lg-12 col-xl-4">
                                                <label className="font-weight-medium mb-0">Retailers</label>
                                            </div>
                                            <div className="col-12 col-lg-12 col-xl-8">
                                                <Select
                                                    isMulti
                                                    value={selectedRetailers}
                                                    options={retailerData}
                                                    onChange={this.handleRetailerChange}
                                                    placeholder="Select who attended"
                                                    className="basic-multi-select"
                                                    isClearable={false}
                                                    maxLength={retailerCount}
                                                    components={{ Menu }} />
                                            </div>
                                        </div>

                                        {/* Retailer Commitment in Kgs */}
                                        {retailersLists}
                                    </div> : null
                            }

                            {/* For Prerak */}
                            {
                                this.isVisible(3) ?
                                    <div>
                                        <div className="form-group acre-form-group row align-items-center">
                                            <div className="col-6 col-lg-6 col-xl-4">
                                                <label className="font-weight-medium mb-0">Prerak Count</label>
                                            </div>
                                            <div className="col-6 col-lg-6 col-xl-8">
                                                <input className="form-control border-right0" type="number" placeholder="0"
                                                    value={prerakCount} onChange={this.onPrerakCountChange} />
                                            </div>
                                        </div>

                                        <div className="form-group row align-items-center">
                                            <div className="col-12 col-lg-12 col-xl-4">
                                                <label className="font-weight-medium mb-0">Preraks</label>
                                            </div>
                                            <div className="col-12 col-lg-12 col-xl-8">
                                                <Select
                                                    isMulti
                                                    value={selectedPreraks}
                                                    options={prerakData}
                                                    onChange={this.handlePrerakChange}
                                                    placeholder="Select who attended"
                                                    className="basic-multi-select"
                                                    isClearable={false}
                                                    maxLength={prerakCount}
                                                    components={{ Menu }} />
                                            </div>
                                        </div>


                                        {/* Prerak Commitment in Kgs */}
                                        {prerakLists}

                                        {/* <div className="form-group acre-form-group row align-items-center">
                                            <div className="col-6 col-lg-6 col-xl-4">
                                                <label className="font-weight-medium mb-0">Prerak 2</label>
                                            </div>
                                            <div className="col-6 col-lg-6 col-xl-8"><div className="form-control">
                                                <input type="text" placeholder="Commitment" /><span>kg</span>
                                            </div>
                                            </div>
                                        </div> */}
                                    </div> : null
                            }

                        </div>
                        <div className="col-lg-12">
                            <AddNumberImages
                                onAddNumber={this.handleNumbers}
                                onAddNumberImages={this.handleNumberImages}
                                images={farmerNumberImages}
                                farmerNumbers={farmerNumbers} />
                        </div>

                        <div className="col-lg-12">
                            <AddNewImages
                                handleAddImages={this.handleAddImages}
                                images={images}
                                handleDeleteImages={this.handleDeleteImages} />
                        </div>

                        <div className="col-lg-12">
                            <div className="form-group">
                                <label className="font-weight-medium mt-2">Feedback </label>
                                <textarea className="form-control" rows="6" name="feedback" value={feedback} onChange={this.changeHandler}></textarea>
                            </div>
                        </div>

                        <div className="col-12 col-lg-12 d-flex button-grp-bottom">
                            <button className="btn btn-secondary w-50 mr-2 krishak-cancel-btn d-md-none" onClick={this.handleBackButton}>{COMMON.BACK}</button>
                            <button className="btn btn-primary w-50 mt-md-4" onClick={this.handleSaveButton} disabled={this.isFormValid()}>{COMMON.SAVE}</button>
                        </div>
                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
                {isLoading ? <Loader /> : null}
            </div >
        )
    }
}

export default withRouter(EditFieldDayPage)